import {
    AdState,
    AllEvents,
    TheWestLiveState,
    TogglesReduxState,
} from '@news-mono/web-common'
import { Logger } from 'typescript-log'
import { getInlinePositionedAds } from '../../../templates/Publication/lib/get-inline-positioned-ads'
import { getInlinePositionedImageLink } from '../../../templates/Publication/lib/get-inline-positioned-imagelink'
import { getInlinePositionedPointer } from '../../../templates/Publication/lib/get-inline-positioned-pointer'
import { getInlinePositionedSportCallToAction } from '../../../templates/Publication/lib/get-inline-positioned-sport-call-to-action'
import { getInlinePositionedSportsHubCta } from '../../../templates/Publication/lib/get-inline-positioned-sports-hub-cta'
import { getInlinePositionedWestLiveBanner } from '../../../templates/Publication/lib/get-inline-positioned-west-live-banner'
import {
    MetaTypes,
    PublicationTypes,
} from '../../../templates/Publication/SharedPublication.routing'
import { getInlinePositionedFederalElectionCta } from '../lib/get-inline-positioned-federal-election-banner'
import { getInlinedPositionedMatchCentreBanner } from '../lib/get-inline-positioned-match-centre-banner'
import { getInlinedPositionedQueenTributeBanner } from '../lib/get-inline-positioned-queen-tribute-banner'
import { getInlinePositionedTaboolaAmp } from '../lib/get-inline-positioned-taboola.amp'

export function getWestInlinePositionedContent(props: {
    adState: AdState
    publication: PublicationTypes
    meta: MetaTypes
    log: Logger
    toggles: TogglesReduxState
    onEvent: (event: AllEvents) => void
    westLiveState?: TheWestLiveState
}) {
    if (!props.publication) {
        return []
    }

    // inline content should not be rendered on gallery publications or events (live blogs)
    if (
        props.publication.kind === 'gallery' ||
        props.publication.kind === 'event' ||
        props.meta.kind === 'gallery' ||
        !props.meta.inlinePublicationContent
    ) {
        return []
    }

    return [
        ...getInlinePositionedAds({
            adState: props.adState,
            publication: props.publication,
            inlinePublicationContent: props.meta.inlinePublicationContent,
            onEvent: props.onEvent,
        }),
        ...getInlinePositionedPointer({
            publication: props.publication,
            inlinePublicationContent: props.meta.inlinePublicationContent,
        }),
        ...getInlinePositionedImageLink({
            publication: props.publication,
            inlinePublicationContent: props.meta.inlinePublicationContent,
        }),
        ...getInlinePositionedSportCallToAction({
            publication: props.publication,
            inlinePublicationContent: props.meta.inlinePublicationContent,
            onEvent: props.onEvent,
        }),
        ...getInlinePositionedWestLiveBanner({
            publication: props.publication,
            inlinePublicationContent: props.meta.inlinePublicationContent,
        }),
        ...getInlinePositionedSportsHubCta({
            inlinePublicationContent: props.meta.inlinePublicationContent,
            publication: props.publication,
        }),
        ...getInlinePositionedTaboolaAmp({
            publication: props.publication,
            inlinePublicationContent: props.meta.inlinePublicationContent,
        }),
        ...getInlinePositionedFederalElectionCta({
            publication: props.publication,
            inlinePublicationContent: props.meta.inlinePublicationContent,
            onEvent: props.onEvent,
        }),
        ...getInlinedPositionedQueenTributeBanner({
            publication: props.publication,
            inlinePublicationContent: props.meta.inlinePublicationContent,
            onEvent: props.onEvent,
        }),
        ...getInlinedPositionedMatchCentreBanner({
            publication: props.publication,
            inlinePublicationContent: props.meta.inlinePublicationContent,
            onEvent: props.onEvent,
        }),
    ]
}
